const USER_KEY = 'sgi_portal_user';

export function savePortalSession(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function portalLogout() {
  localStorage.removeItem(USER_KEY);
}

export function isPortalAuthenticated() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return false;
    const user = JSON.parse(raw);
    return typeof user.exp === 'number' && user.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export function getPortalUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
